import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { togglePopup } from 'actions/appAction';

import amplitude from 'amplitude-js';

import { LightDangerouslyHtml } from '../no-auth/common/fromAuth/LightDangerouslyHtml/LightDangerouslyHtml';
import PromoPopupButton from '../no-auth/popup/PromoPopupButton';
import PromoSimplePopup from '../no-auth/popup/PromoSimplePopup';

const PromoTextPopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        if (props.eventInfo) {
            amplitude.getInstance().logEvent(props.eventInfo.name, props.eventInfo.params);
        }
    }, []);

    const getText = (text) => {
        return <LightDangerouslyHtml dangerouslyHtml={text} />;
    };

    const onClick = () => {
        if (props.onClick) {
            props.onClick();
        }
        if (popupRef?.current) {
            popupRef.current?.close();
        } else {
            props.togglePopup(false);
        }
    };

    return (
        <PromoSimplePopup text={getText(props.text)} popupRef={popupRef}>
            <PromoPopupButton iconName="check" text={props.buttonText} onClick={onClick} />
        </PromoSimplePopup>
    );
};

export default connect(null, { togglePopup })(PromoTextPopup);

PromoTextPopup.propTypes = {
    onClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};
